import { createContext, useContext, useEffect, useState } from "react";
import { fetchFirm } from "../lib/api";

const FirmContext = createContext(null);

export const FirmProvider = ({ children }) => {
  const [firm, setFirm] = useState(null);
  useEffect(() => {
    fetchFirm().then(setFirm).catch((e) => console.error("firm fetch failed", e));
  }, []);
  return <FirmContext.Provider value={firm}>{children}</FirmContext.Provider>;
};

export const useFirm = () => useContext(FirmContext);
